import tw from "twin.macro"
import Icon from "../../../atoms/Icon"
import { FeaturesCategoryFilterProps } from "./KeyFeaturesModuleProps"
import { useContext } from "react"
import { LanguageContext } from "../../../../contexts/Language"
import { Select, Option } from "../../../atoms/Select"

const FeaturesCategoryFilter = ({
  categories,
  selectedCategory,
  showFilter,
  setShowFilter,
  handleSelectChange,
}: FeaturesCategoryFilterProps) => {
  const { _ } = useContext(LanguageContext)

  return (
    <div
      css={[
        tw`w-full mx-auto flex flex-col justify-center text-center mt-10 gap-5 text-lg lg:(mt-20)`,
      ]}
    >
      <div>
        <button
          css={[
            tw`w-full bg-black rounded-md py-2 px-4 mx-auto text-white font-semibold flex items-center justify-between gap-5`,
          ]}
          onClick={() => setShowFilter(!showFilter)}
        >
          {categories[selectedCategory]?.title}
          <Icon.Chevron
            color="white"
            direction="down"
            css={[
              tw`h-3 transition-all duration-300 mt-0.5 ml-1`,
              showFilter && tw`transform -rotate-180`,
            ]}
          />
        </button>
      </div>

      <ul css={[tw`flex flex-col justify-center gap-3 mb-6`]}>
        {showFilter &&
          categories?.map(
            (category: { title: string; _key: string }, index: number) => {
              const isActive = selectedCategory === index
              return (
                <li key={category._key} css={[tw`flex w-full justify-center`]}>
                  <button
                    css={[
                      isActive
                        ? tw`bg-black text-white hover:(bg-gray-800)`
                        : tw`bg-wildSand py-2 px-5 rounded-full flex items-center gap-2 hover:(bg-[#ecebeb])`,
                      tw`py-2 px-5 rounded-full flex items-center gap-2 w-full text-center`,
                    ]}
                    onClick={() => {
                      handleSelectChange(index), setShowFilter(!showFilter)
                    }}
                  >
                    {category.title}
                  </button>
                </li>
              )
            },
          )}
      </ul>
    </div>
  )
}

export default FeaturesCategoryFilter
